import React from 'react';
import { useApplicationState } from '../../../state/ApplicationContext';
import { SectionCard } from '../../form/SectionCard';
import { MultiSelectChips } from '../MultiSelectChips';
import { CurrencyField } from '../../form/CurrencyField';
import { TextField } from '../../form/TextField';
const GOAL_OPTIONS = [{
  value: 'lower_rate',
  label: 'Lower Interest Rate'
}, {
  value: 'lower_payment',
  label: 'Lower Payment'
}, {
  value: 'remove_pmi',
  label: 'Remove PMI'
}, {
  value: 'remove_borrower',
  label: 'Remove Borrower'
}, {
  value: 'cash_out',
  label: 'Cash Out'
}, {
  value: 'other',
  label: 'Other'
}];
const CASH_OUT_PURPOSES = [{
  value: 'debt_consolidation',
  label: 'Debt Consolidation'
}, {
  value: 'home_improvement',
  label: 'Home Improvements'
}, {
  value: 'title_buyout',
  label: 'Title Buyout'
}, {
  value: 'other',
  label: 'Other'
}];
export function ClientGoalsSection() {
  const {
    state,
    dispatch
  } = useApplicationState();
  const {
    goals
  } = state;
  const update = (payload: Partial<typeof goals>) => {
    dispatch({
      type: 'UPDATE_GOALS',
      payload
    });
  };
  const isCashOut = goals.selectedGoals.includes('cash_out');
  const isOtherGoal = goals.selectedGoals.includes('other');
  const isOtherPurpose = goals.cashOutPurposes.includes('other');
  return <div className="space-y-6" data-id="element-61">
      <SectionCard title="What are the client's primary goals?" data-id="element-62">
        <div className="space-y-6" data-id="element-63">
          <MultiSelectChips options={GOAL_OPTIONS} values={goals.selectedGoals} onChange={v => update({
          selectedGoals: v
        })} data-id="element-64" />

          {isOtherGoal && <div className="animate-in fade-in slide-in-from-top-2" data-id="element-65">
              <TextField label="Please specify other goal" value={goals.otherGoal} onChange={v => update({
            otherGoal: v
          })} data-id="element-66" />
            </div>}

          {isCashOut && <div className="mt-6 p-6 bg-blue-50/50 rounded-xl border border-blue-100 space-y-6 animate-in fade-in slide-in-from-top-2" data-id="element-67">
              <h4 className="font-semibold text-gray-900" data-id="element-68">Cash Out Details</h4>
              <CurrencyField label="Desired Cash Amount" value={goals.cashOutAmount} onChange={v => update({
            cashOutAmount: v
          })} data-id="element-69" />

              <div className="space-y-3" data-id="element-70">
                <label className="text-sm font-medium text-gray-700" data-id="element-71">
                  Purpose of Funds
                </label>
                <MultiSelectChips options={CASH_OUT_PURPOSES} values={goals.cashOutPurposes} onChange={v => update({
              cashOutPurposes: v
            })} data-id="element-72" />
              </div>

              {isOtherPurpose && <TextField label="Please specify other purpose" value={goals.customPurpose} onChange={v => update({
            customPurpose: v
          })} data-id="element-73" />}
            </div>}
        </div>
      </SectionCard>
    </div>;
}